module.exports = __webpack_public_path__ + "static/img/1-4.65b0695.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature/face/1-4.png
// module id = wYF4
// module chunks = 1